export enum WorksheetMode {
    STANDALONE,
    TEMPLATE,
    LINKED
}